<template lang='pug'>
  bf-flex#bf-translate.centered
    select.languages(v-model='locale' @change='translate')
      option.english.language(value='en') English
      option.spanish.language(value='es') Español
      option.chinese.language(value='ch') 中文
</template>

<script>
  import { Translatable } from '@/mixins/view'

  export default {
    name: 'component.bf-translate',
    mixins: [ Translatable ],
  }

</script>

<style scoped lang='stylus'>
  #bf-translate
    font-size 1.2em
    margin-bottom 16px
    padding 8px 0

  select
    color var(--clr-light)
    background var(--clr-orange)
    width auto
    border-radius 4px
    padding 4px 12px
    font-size 1.2em
    option
      color black
      background 0
</style>
